/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';

import {
  getDetailsMonthlyHeader,
  getMonthlyLinesByUbicationSimplifiedC,
  getMonthlyLinesByPositionLineSimplifiedC
} from '../../services/monthlyServiceRequest';
import { ubicationTypeEnum } from '../../utils/dataStatus';
import useToast from '../useToast';
import LoaderContext from '../../context/LoaderProvider';
import { useFilterContext } from '../../context/FilterDetailSDSContext';

import { buildChildrenOfUbications, buildChildrenOfPartJobLine } from './utils';

const useSimplifiedCharging = ({ id, isOrderByUbication }) => {
  const [loading, setLoading] = useState(false);
  const [dataForSheet, setDataForSheet] = useState([]);
  const [linesByUbication, setLinesByUbication] = useState([]);
  const [linesByPostionLIne, setLinesByPostionLIne] = useState([]);
  const [forceWindow, setForceWindow] = useState();
  const [validityDate, setValidityDate] = useState(undefined);
  const [hasTechnicalLocations, setHasTechnicalLocations] = useState(true);
  const [ubicationsData, setUbicationsData] = useState({});
  const { setLoader } = useContext(LoaderContext);
  const { filter } = useFilterContext();

  const { setNewToast } = useToast();
  const getNotificationWindowState = async () => {
    setLoader(true);
    try {
      const { forzarVentanaNotificacion, fechaVigencia, tieneUbicacionesTecnicas } =
        await getDetailsMonthlyHeader(id);

      setForceWindow(forzarVentanaNotificacion);
      setValidityDate(fechaVigencia);
      setHasTechnicalLocations((prevState) => prevState && tieneUbicacionesTecnicas);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getNotificationWindowState();
  }, [id]);

  const typeUbications = () => {
    if (filter?.ubicationType) {
      return [filter?.ubicationType?.id];
    }
    if (filter?.tipoUbicacionesIds) {
      return filter?.tipoUbicacionesIds?.map((ubic) => ubic);
    }

    return [];
  };

  const ubicationsFilter = () => {
    if (filter?.ubications) {
      return [filter?.ubications?.id];
    }
    if (filter?.ubicacionesIds) {
      return filter?.ubicacionesIds?.map((ubic) => ubic);
    }

    return [];
  };

  const fetchTotalUbicationsMonthly = async () => {
    const body = {
      ...(isOrderByUbication && {
        equiposIds: filter?.towerEquipments
          ? filter?.towerEquipments?.map((equip) => equip?.id)
          : filter?.equiposIds?.map((equip) => equip)
      }),
      ...(isOrderByUbication && {
        eventosIds: filter?.events
          ? filter?.events?.map((evnt) => evnt?.id)
          : filter?.eventosIds?.map((evnt) => evnt)
      }),
      tipoUbicacionesIds: typeUbications(),
      ubicacionesIds: ubicationsFilter(),
      posicionesLineas: filter?.posicionesLineas?.map((pos) => ({
        posicionId: pos?.posicionId,
        lineaId: pos?.lineaId,
        posicion: pos?.posicion,
        linea: pos?.linea
      }))
    };

    const ubications = await getMonthlyLinesByUbicationSimplifiedC(id, {
      fechaVigencia: validityDate,
      forzarVentanaNotificacion: forceWindow,
      filtros: body
    });
    const ubicationsWithLines = ubications?.filter((ubication) => ubication.lineas.length > 0);
    const ubicationsIdsWell = ubications?.map((ubication) => ({
      idsEventoPozo: ubication.idsEventoPozo
    }));

    setLinesByUbication(ubicationsWithLines);
    setUbicationsData((prevState) => ({ ...prevState, ubicationsIdsWell }));
  };

  const fetchPositionLinesMonthly = async () => {
    const body = {
      ...(isOrderByUbication && {
        equiposIds: filter?.towerEquipments
          ? filter?.towerEquipments?.map((equip) => equip?.id)
          : filter?.equiposIds?.map((equip) => equip)
      }),
      ...(isOrderByUbication && {
        eventosIds: filter?.events
          ? filter?.events?.map((evnt) => evnt?.id)
          : filter?.eventosIds?.map((evnt) => evnt)
      }),
      tipoUbicacionesIds: typeUbications(),
      ubicacionesIds: ubicationsFilter(),
      posicionesLineas: filter?.posicionesLineas?.map((pos) => ({
        posicionId: pos?.posicionId,
        lineaId: pos?.lineaId,
        posicion: pos?.posicion,
        linea: pos?.linea
      }))
    };
    const positionsLines = await getMonthlyLinesByPositionLineSimplifiedC(id, {
      fechaVigencia: validityDate,
      forzarVentanaNotificacion: forceWindow,
      filtros: body
    });

    setLinesByPostionLIne(positionsLines);
  };

  const setRangesOfUbications = () => {
    const arrayOfRanges = [];

    linesByUbication?.forEach((ubication, index) => {
      arrayOfRanges.push({
        initialRange:
          index === 0
            ? 0
            : arrayOfRanges.reduce(
                (acc, curr) => acc + (curr.finalRange - curr.initialRange + 1),
                0
              ),
        finalRange:
          index === 0
            ? arrayOfRanges.reduce((acc, curr) => acc + (curr.finalRange - curr.initialRange), 0) +
              ubication.lineas.length -
              1
            : arrayOfRanges.reduce(
                (acc, curr) => acc + (curr.finalRange - curr.initialRange + 1),
                0
              ) +
              ubication.lineas.length -
              1
      });
    });

    return arrayOfRanges;
  };

  const setRangesOfPartJobLine = () => {
    const arrayOfRanges = [];

    linesByPostionLIne.forEach((partJobLine, index) => {
      arrayOfRanges.push({
        initialRange:
          index === 0
            ? 0
            : arrayOfRanges.reduce(
                (acc, curr) => acc + (curr.finalRange - curr.initialRange + 1),
                0
              ),
        finalRange:
          index === 0
            ? arrayOfRanges.reduce((acc, curr) => acc + (curr.finalRange - curr.initialRange), 0) +
              partJobLine.ubicaciones.length -
              1
            : arrayOfRanges.reduce(
                (acc, curr) => acc + (curr.finalRange - curr.initialRange + 1),
                0
              ) +
              partJobLine.ubicaciones.length -
              1
      });
    });

    return arrayOfRanges;
  };

  const setUbicationData = () => {
    const rangesOfUbications = setRangesOfUbications();
    const groupsUbicationPartJob = linesByUbication?.map((ubication, ubicationIndex) => ({
      id: ubication.idUbicacion,
      children: ubication.lineas.map((linea) =>
        buildChildrenOfUbications({
          tipoEvento: ubication.tipoEvento,
          nombreEquipo: ubication.nombreEquipo,
          fechasEvento: ubication.fechasEvento,
          ubicationId: ubication.idUbicacion,
          ubicationName: ubication.ubicacionNombre,
          ubicationFinished: ubication?.finalizada,
          numberOfLines: ubication.lineas.length,
          partJobLine: linea,
          rangesOfUbications: rangesOfUbications[ubicationIndex],
          activeDates: ubication.fechasActivas,
          isOyM: ubication.tipoUbicacion > ubicationTypeEnum.pozo,
          idsEventoPozo: ubication.idsEventoPozo,
          lineBlockedBySap: linea?.bloqueadoEnSap
        })
      )
    }));

    setDataForSheet(groupsUbicationPartJob);
  };

  const setPositionLineData = () => {
    const rangesOfUbications = setRangesOfPartJobLine();
    const groupsPartJobLines = linesByPostionLIne.map((partJobLine, partJobLineIndex) => ({
      id: partJobLine.idParteTrabajoLinea,
      children: partJobLine.ubicaciones.map((ubicacion) =>
        buildChildrenOfPartJobLine({
          nameLine: partJobLine.nombrePosicionSap ?? '',
          namePosition: partJobLine.nombrePosicionSap ?? '',
          numberLine: partJobLine.numeroLinea ?? 0,
          numberPosition: partJobLine.numeroPosicion ?? 0,
          numberOfLines: partJobLine.ubicaciones?.length ?? 0,
          unitMeasureValue: partJobLine.unidadMedida ?? '',
          partJobLineId: partJobLine.idParteTrabajoLinea ?? null,
          ubication: ubicacion ?? {},
          ranges: rangesOfUbications[partJobLineIndex] ?? { initialRange: 0, finalRange: 0 },
          isOyM: (ubicacion?.tipoUbicacion ?? 0) > ubicationTypeEnum.pozo,
          lineBlockedBySap: partJobLine?.bloqueadoEnSap ?? false
        })
      )
    }));

    setDataForSheet(groupsPartJobLines);
  };

  const getDataForSheet = async () => {
    try {
      setLoading(true);
      if (isOrderByUbication === 'true') {
        fetchTotalUbicationsMonthly();
      } else {
        fetchPositionLinesMonthly();
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setNewToast({
        type: 'error',
        message: err.message
      });
    }
  };

  useEffect(() => {
    if (validityDate === undefined || forceWindow === undefined || filter?.haveFilters === false)
      return;
    getDataForSheet();
  }, [validityDate, forceWindow, filter]);

  useEffect(() => {
    if (isOrderByUbication === 'true') {
      setUbicationData();
    } else {
      setPositionLineData();
    }
  }, [linesByUbication, linesByPostionLIne]);

  return {
    dataForSheet,
    setDataForSheet,
    forceWindow,
    getDataForSheet,
    linesByPostionLIne,
    linesByUbication,
    loading,
    setLoading,
    hasTechnicalLocations,
    ubicationsData
  };
};

export default useSimplifiedCharging;
